/* src/app/components/lead-details/additional-attributes/additional-attributes.component.css */
/*# sourceMappingURL=additional-attributes.component-BCICZYP6.css.map */
